import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { formatLocalDate } from "@/utils/dateUtils";

// get_plataforma_carga_diaria (sql/161) ainda não está no types.ts gerado ->
// cast, mesmo padrão do useAgenciaTimeline (RPC nova fora do types.ts).
const plataformaDb = supabase as unknown as {
  rpc: (functionName: string, args: Record<string, unknown>) => any; // eslint-disable-line @typescript-eslint/no-explicit-any
};

export type PeriodoPlataforma = "90d" | "12m" | "24m";

/** Um dia da série de carga da plataforma inteira. `dia` é data lógica "YYYY-MM-DD". */
export interface PlataformaCargaDiariaPonto {
  dia: string;
  freelancers_ativos: number;
  projetos_ativos: number;
}

function periodoParaDataInicio(periodo: PeriodoPlataforma): string | null {
  const inicio = new Date();
  if (periodo === "90d") {
    inicio.setDate(inicio.getDate() - 90);
  } else if (periodo === "12m") {
    inicio.setMonth(inicio.getMonth() - 12);
  } else {
    inicio.setMonth(inicio.getMonth() - 24);
  }
  return formatLocalDate(inicio) ?? null;
}

/**
 * Carga diária da PLATAFORMA INTEIRA (freelancers/projetos ativos por dia),
 * via get_plataforma_carga_diaria (sql/161) — variante global guardada de
 * get_agencia_carga_diaria (sql/150). Só usuário interno enxerga dado (a RPC
 * devolve vazio pra portal de agência); a tela de Dashboard interno já é
 * protegida por requiredScreen="dashboard" antes de chegar aqui.
 */
export function usePlataformaCarga(periodo: PeriodoPlataforma = "12m") {
  return useQuery({
    queryKey: ["plataforma-carga", periodo],
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<PlataformaCargaDiariaPonto[]> => {
      const dataInicio = periodoParaDataInicio(periodo);
      const { data, error } = await plataformaDb.rpc("get_plataforma_carga_diaria", {
        p_from: dataInicio,
        p_to: formatLocalDate(new Date()),
      });
      if (error) throw error;
      return (data as PlataformaCargaDiariaPonto[]) ?? [];
    },
  });
}
